import APIService from './APIService';

export default {
  getAll() {
    return APIService.apiCall().get('/malhas/get-all');
  },
  executar(id) {
    return APIService.apiCall().get(`/malhas/executar/${id}`);
  },
  deletar(id) {
    return APIService.apiCall().get(`/malhas/excluir/${id}`);
  },
  save(postData) {
    return APIService.apiCall().post('/malhas/save', JSON.stringify(postData));
  },
  baixarLogsTecnicos(id) {
    return APIService.apiCall().get(`/malhas/logs-tecnicos/${id}`, {
      responseType: 'blob',
      ...{
        timeout: 60 * 60 * 1000
      }
    });
  }
};
